const columnsProduct = [
  {
    title: 'STT',
    key: 'stt',
  },
  {
    title: 'Hình ảnh',
    key: 'image',
  },
  {
    title: 'Mã món ăn',
    dataIndex: 'sku',
  },
  {
    title: 'Tên món ăn',
    dataIndex: 'name',
    key: 'name-product',
  },

  {
    title: 'Phân loại món',
    key: 'category',
  },
  {
    title: 'Ngày tạo',
    key: 'create_date',
  },
  {
    title: 'Mở bán',
    key: 'active',
  },
  {
    title: 'Hành động',
    key: 'action',
  },
]

export default columnsProduct
